/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from "react";

export const PromoContext = React.createContext();

export const PromoProvider = ({ children }) => {
  const deadline = new Date("2024-04-01T07:00:00.000Z");
  const promoInfo = {
    deadline,
    text: "Special Deal Ending Soon!",
    showCountDown: Date.now() < deadline.getTime(),
  };
  const contextValue = useMemo(
    () => ({ promoInfo }),
    [promoInfo],
  );

  return (
    <PromoContext.Provider value={contextValue}>
      {children}
    </PromoContext.Provider>
  );
};

export const withPromo = (Component) => (props) =>
  (
    <PromoContext.Consumer>
      {(context) => <Component {...props} themeContext={context} />}
    </PromoContext.Consumer>
  );
